import api from "./api";
// import TokenService from "./token.service";

export const updateProfile = async (params) => {
    return api.patch("/v1/cp/my/profile", params);
}

export const changePassword = async (params) => {
    return api.post("/v1/cp/my/change-password", params);
}
  
export const getActivities = async () => {
    return api.get("/v1/cp/my/activities");
}
  